<template>
  
  <div v-if="hasLoad" id="print_kw_box" class="kw_list" ref="print_kw_box" element-loading-spinner="el-icon-loading" :style="'height:100%;'+(pageSetInfo.styleSet.pageBoxStyleSet?pageSetInfo.styleSet.pageBoxStyleSet.styleSetCode:'')" kwName="pageBoxStyleSet" >
    <!--visitSource = 2  PC端 -->
    <el-container class="MailHome" v-if="visitSource == 2 || visitSource == 3">
      <!-- 判断是否有左侧树页面 如果有 则进行左侧树的显示 -->
      <el-aside v-if="pageSetInfo.leftTreePageId>0 && visitSource == 2" width="200px" :style="'background-color: #fff;margin: 0px 5px 0 0px;padding: 10px 0 0 5px;height:'+pageHeight+'px;'">
        <kw_tree_list ref="kw_list_left_tree" :initPageObj="{tableId:pageSetInfo.leftTreeTableId,pageId:pageSetInfo.leftTreePageId,dataMaxNum:1}" :mainId="mainId" @dialogClickCallBack="leftTreeClick" :treeType="0"></kw_tree_list>
      </el-aside>
      <!-- 搜索条件 判断搜索条件的显示形式 -->
      <el-container style="display: block;">
        <el-row type="flex" justify="center" :style="((dataMaxNum != 1 && ifDialog)?'height: '+(pageHeight-20)+'px;overflow-y: scroll;':'')+('width:100%;background:'+pageSetInfo.styleSet.bgColor+';')">
          <el-col :xs="24" :sm="24" :md="24" :lg="pageSetInfo.styleSet.rotationChartScreenLg?pageSetInfo.styleSet.rotationChartScreenLg*1:24" :xl="pageSetInfo.styleSet.rotationChartScreenXl?pageSetInfo.styleSet.rotationChartScreenXl*1:24">
            <!-- 列表操作按钮条按钮 -->
            <div v-if="(pageSetInfo.listStyleSet.pageButtonLoaction!=2)" :style="(((pageSetInfo.outFieldArr.length > 0 || pageSetInfo.inFieldArr.length > 0) && ifShowSearch == 0 && visitSource == 2)?'position: absolute;right: 40px;top: 8px;display: flex;':'margin:5px 20px;')+(pageSetInfo.searchStyleSet.searchButtonBoxStyleSet?pageSetInfo.searchStyleSet.searchButtonBoxStyleSet.styleSetCode:'')" kwName="searchButtonBoxStyleSet"> 
              <div v-if="(pageSetInfo.outFieldArr.length > 0 || pageSetInfo.inFieldArr.length > 0) && ifShowSearch == 0 && (!pageSetInfo.searchStyleSet ||pageSetInfo.searchStyleSet.searchButtonStyle != 1) && visitSource == 2" class="listButtonPc"  @click="initLoadDataInfo()" :style="(pageSetInfo.searchStyleSet.searchCommonStyleSet?pageSetInfo.searchStyleSet.searchCommonStyleSet.styleSetCode:'')" kwName="searchCommonStyleSet"><i class="el-icon-search"></i></div>
              <kw_btn_array v-if="(pageSetInfo.buttonSet && pageSetInfo.buttonSet.length>0) && pageSetInfo.buttonSetIfHide" type="buttonSet" :pageSetInfo="pageSetInfo" @dataButtonClick="pageButtonClick" :previewVisitSource="previewVisitSource" :isLimitButton="isLimitButton"></kw_btn_array>
            </div>
            <!-- <div :style="transmitData.setSticky==2?'position:sticky;top: 0px;z-index:999;box-shadow: 0 -1px #fff':'z-index:1'"> -->
            <img @click="listBgImageJump" v-if="(pageSetInfo.listStyleSet.listBgImageStyle)" :src="(GLOBAL.getFileServeUrl()+pageSetInfo.listStyleSet.listBgImageStyle)" 
            :style="'width:100%;height:40px;'+(pageSetInfo.listStyleSet.listBgImageCommonStyleSet?pageSetInfo.listStyleSet.listBgImageCommonStyleSet.styleSetCode:'')" kwName="listBgImageCommonStyleSet"/>
            <!-- 'margin:0 0 20px 0;'+ -->
            <kw_search v-if="pageSetInfo.searchStyleSet.searchShowStyle == 2 || (visitSource == 3 && pageSetInfo.listStyleSet.showStyle>0)" :ref="'kw_search_'+tableId" :id="'kw_search_'+tableId" v-model="kwSearchToHtData" :pageSetInfo="pageSetInfo" @loadDataInfo="initLoadDataInfo" :initSearchVal="initSearchVal" :htPageDataInfo="htPageDataInfo" :mainId="mainId" @setShowDataFilter="setShowDataFilter" :previewVisitSource="previewVisitSource"  :style="(pageSetInfo.searchStyleSet.searchBlockBoxStyleSet?pageSetInfo.searchStyleSet.searchBlockBoxStyleSet.styleSetCode:'')" kwName="searchBlockBoxStyleSet"></kw_search>
            <el-collapse :class="visitSource == 3?'phone_collapse':''"  v-else-if="((pageSetInfo.outFieldArr.length > 0 || pageSetInfo.inFieldArr.length > 0) && ifShowSearch == 0 && visitSource == 2) || (visitSource == 3 && !pageSetInfo.listStyleSet.showStyle)"  v-model="kwSearchFlag">
              <el-collapse-item title="搜索条件" name="1">
                <div v-if="visitSource == 2" slot="title" style="margin:0 0 0 10px;">
                  搜索条件<i :class="kwSearchFlag=='1'?'el-icon-remove':'el-icon-circle-plus'"></i>
                </div>
                <div v-if="visitSource == 3" slot="title" style="margin:0 0 0 auto;">
                  <img style="width:20px;height:16px;margin:0 5px 3px 0" src="./img/search.png"/>
                  <span style="font-size:14px;color:#FE8546;">搜索</span>
                </div>
                <kw_search :ref="'kw_search_'+tableId" :id="'kw_search_'+tableId" v-model="kwSearchToHtData" :pageSetInfo="pageSetInfo" @loadDataInfo="initLoadDataInfo" :initSearchVal="initSearchVal" :htPageDataInfo="htPageDataInfo" :mainId="mainId" @setShowDataFilter="setShowDataFilter" :previewVisitSource="previewVisitSource" :style="(pageSetInfo.searchStyleSet.searchBlockBoxStyleSet?pageSetInfo.searchStyleSet.searchBlockBoxStyleSet.styleSetCode:'')" kwName="searchBlockBoxStyleSet"></kw_search>
                <div v-if="visitSource == 3" style="text-align: center;margin: 15px 0 0 0;">
                  <el-button  type="primary" size="medium" class="" @click="clearSearchVal" style="background: #fff;color:#FE8546;">重置</el-button>
                  <el-button v-if="(pageSetInfo.outFieldArr.length > 0 || pageSetInfo.inFieldArr.length > 0) && ifShowSearch == 0 && (!pageSetInfo.searchStyleSet ||pageSetInfo.searchStyleSet.searchButtonStyle != 1) && visitSource == 3" type="primary" size="medium" class="" @click="initLoadDataInfo()" :style="'background: #FE8546;'+(pageSetInfo.searchStyleSet.searchCommonStyleSet?pageSetInfo.searchStyleSet.searchCommonStyleSet.styleSetCode:'')" kwName="searchCommonStyleSet">搜索</el-button>
                </div>
              </el-collapse-item>
            </el-collapse>

            <div v-if="(pageSetInfo.listStyleSet.pageButtonLoaction==2)" :style="'border-top: 1px solid #c8c8c8;border-bottom: 1px solid #c8c8c8;padding: 0 0 0 30px;'+(pageSetInfo.searchStyleSet.searchButtonBoxStyleSet?pageSetInfo.searchStyleSet.searchButtonBoxStyleSet.styleSetCode:'')" kwName="searchButtonBoxStyleSet"> 
              <div v-if="(pageSetInfo.outFieldArr.length > 0 || pageSetInfo.inFieldArr.length > 0) && ifShowSearch == 0 && (!pageSetInfo.searchStyleSet ||pageSetInfo.searchStyleSet.searchButtonStyle != 1) && visitSource == 2" class="listButtonPc"  @click="initLoadDataInfo()" :style="(pageSetInfo.searchStyleSet.searchCommonStyleSet?pageSetInfo.searchStyleSet.searchCommonStyleSet.styleSetCode:'')" kwName="searchCommonStyleSet"><i class="el-icon-search"></i></div>
              <kw_btn_array v-if="(pageSetInfo.buttonSet && pageSetInfo.buttonSet.length>0) && pageSetInfo.buttonSetIfHide" type="buttonSet" :pageSetInfo="pageSetInfo" @dataButtonClick="pageButtonClick" :previewVisitSource="previewVisitSource" :isLimitButton="isLimitButton"></kw_btn_array>
            </div>

            <!-- </div> -->
            <!-- 总记录数 -->
            <div class="xueTit" v-if="(pageSetInfo.listStyleSet && pageSetInfo.listStyleSet.pageTotalStyle==2)">
              <div class="currentTitle" v-if="(pageSetInfo.listStyleSet && pageSetInfo.listStyleSet.pageTotalStyle==2)">当天共有<span>{{paginationInfo.total}}</span>个任务</div>
            </div>
            <div class='listCon' v-loading="(!ifLoadedData || isLoading)" element-loading-spinner="el-icon-loading" >
              <!-- 默认样式 -->
              <template v-if="((!pageSetInfo.listStyleSet.showStyle && visitSource == 2) || pageSetInfo.listStyleSet.showStyle == 1 || (pageSetInfo.listStyleSet.showStyle == '' && visitSource == 2))">
                <kw_list_default v-if="ifLoadedData" ref="kw_list_default" :listFieldSet="pageSetInfo.listFieldSet" :pageSetInfo="pageSetInfo" :initCheckId="initCheckId?(initCheckId+''):''" :dataMaxNum="dataMaxNum" :dataList="pageDataInfo" @callbackevent="callBackEvent" @refreshevent="refreshevent" :isLimitButton="isLimitButton" @getParentKwLook="getParentKwLook"></kw_list_default>
                <!-- <kw_card_default :listFieldSet="pageSetInfo.listFieldSet" :pageSetInfo="pageSetInfo"
                                :dataList="pageDataInfo" @callbackevent="callBackEvent" @refreshevent="refreshevent"></kw_card_default> -->
              </template>
              <template v-else-if="(!pageSetInfo.listStyleSet || pageSetInfo.listStyleSet.showStyle<=2 || (pageSetInfo.listStyleSet.showStyle<=10 && pageSetInfo.listStyleSet.showStyle>=6) || (!pageSetInfo.listStyleSet.showStyle && visitSource == 3))">
                <kw_card_default ref="kw_card_default" :listFieldSet="pageSetInfo.listFieldSet" :pageSetInfo="pageSetInfo" :dataMaxNum="dataMaxNum" :ifDialog="ifDialog" :initCheckId="initCheckId?(initCheckId+''):''"
                                :dataList="pageDataInfo" @callbackevent="callBackEvent" @refreshevent="refreshevent" :previewVisitSource="previewVisitSource" :isLimitButton="isLimitButton" @getParentKwLook="getParentKwLook"></kw_card_default>
              </template>
              <!-- 树形标签二级 -->
              <template v-else-if="(pageSetInfo.listStyleSet.showStyle==4)" >
                <kw_tree_label :listFieldSet="pageSetInfo.listFieldSet" :pageSetInfo="pageSetInfo" :dataList="pageDataInfo" :initCheckId="initCheckId" :dataMaxNum="dataMaxNum" @callbackevent="callBackEvent" ></kw_tree_label>
              </template>
              <!-- 选项卡列表 -->
              <template v-else-if="(pageSetInfo.listStyleSet.showStyle==5)" >
                <kw_list_label :listFieldSet="pageSetInfo.listFieldSet" :pageSetInfo="pageSetInfo" :dataList="pageDataInfo" :initCheckId="initCheckId" :dataMaxNum="dataMaxNum" :mainId="mainId" @callbackevent="callBackEvent" @goBack="goBack" @refreshevent="refreshevent" :previewVisitSource="previewVisitSource" :isLimitButton="isLimitButton"></kw_list_label>
                <!-- <span class="chooseProBtnPC" v-for="(item,index) in pageSetInfo.buttonSet" :class="item.styleSet.buttonSetButtonStyleSet?item.styleSet.buttonSetButtonStyleSet.defineHover : ' '" :key="'buttonId_'+index" @click="pageButtonClick(item)">{{item.buttonName}}</span> -->
              </template>
              <!-- 折叠面板列表 -->
              <template v-else-if="(pageSetInfo.listStyleSet.showStyle==11)" >
                <kw_list_collapse :listFieldSet="pageSetInfo.listFieldSet" :pageSetInfo="pageSetInfo" :dataList="pageDataInfo" :initCheckId="initCheckId" :dataMaxNum="dataMaxNum" @callbackevent="callBackEvent" :isLimitButton="isLimitButton"></kw_list_collapse>
              </template>
              <!-- 轮播图列表组件 -->
              <template v-else-if="(pageSetInfo.listStyleSet.showStyle==12)" >
                <kw_list_carousel :listFieldSet="pageSetInfo.listFieldSet" :pageSetInfo="pageSetInfo" :dataList="pageDataInfo" :initCheckId="initCheckId" :dataMaxNum="dataMaxNum" @callbackevent="callBackEvent" :previewVisitSource="previewVisitSource"></kw_list_carousel>
              </template>
              <!-- 单行列表 -->
              <template v-else-if="(pageSetInfo.listStyleSet.showStyle==13)" >
                <div :style="pageSetInfo.listStyleSet.listPageCellBoxExternalBoxStyleSet?pageSetInfo.listStyleSet.listPageCellBoxExternalBoxStyleSet.styleSetCode:''" kwName="listPageCellBoxExternalBoxStyleSet">
                  <kw_list_cell :listFieldSet="pageSetInfo.listFieldSet" :pageSetInfo="pageSetInfo" :dataList="pageDataInfo" @callbackevent="callBackEvent" @refreshevent="initLoadDataInfo" :isLimitButton="isLimitButton"></kw_list_cell>
                </div>
              </template>
              <!-- 知识体系树列表 -->
              <template v-else-if="(pageSetInfo.listStyleSet.showStyle==14)" >
                <kw_tree :dataList="pageDataInfo" :pageSetInfo="pageSetInfo" :isLimitButton="isLimitButton"></kw_tree>
              </template>
              <!-- 树形结构列表 -->
              <template v-else-if="(pageSetInfo.listStyleSet.showStyle==21)" >
                <lmf_tree :initListData="pageDataInfo" :pageSetInfo="pageSetInfo" :isLimitButton="isLimitButton"></lmf_tree>
              </template>
              <!-- 评论列表(kw_list_comment) -->
              <template v-else-if="(pageSetInfo.listStyleSet.showStyle==15)" >
                <kw_list_comment :listFieldSet="pageSetInfo.listFieldSet" :pageSetInfo="pageSetInfo" :dataList="pageDataInfo" @callbackevent="callBackEvent" @refreshevent="initLoadDataInfo"></kw_list_comment>
              </template>
              <!-- 搜索组件(kw_list_search) -->
              <template v-else-if="(pageSetInfo.listStyleSet.showStyle==16)" >
                <kw_list_search :listFieldSet="pageSetInfo.listFieldSet" :pageSetInfo="pageSetInfo" :dataList="pageDataInfo" @callbackevent="callBackEvent" @refreshevent="initLoadDataInfo"></kw_list_search>
              </template>
              <!-- 菜单产品类型-->
              <template v-else-if="(pageSetInfo.listStyleSet.showStyle==17)" >
                <kw_menu_lable :listFieldSet="pageSetInfo.listFieldSet" :pageSetInfo="pageSetInfo" :dataList="pageDataInfo" :initCheckId="initCheckId" :dataMaxNum="dataMaxNum" @callbackevent="callBackEvent" ></kw_menu_lable>
              </template>
              <!-- 排行榜(kw_ranking_list) -->
              <template v-else-if="(pageSetInfo.listStyleSet.showStyle==18)" >
                <kw_ranking_list :listFieldSet="pageSetInfo.listFieldSet" :pageSetInfo="pageSetInfo" :dataList="pageDataInfo" @callbackevent="callBackEvent" @refreshevent="initLoadDataInfo" :previewVisitSource="previewVisitSource"></kw_ranking_list>
              </template>
              <!-- 进度条 -->
              <template v-else-if="(pageSetInfo.listStyleSet.showStyle==19)">
                <div class="progressContent_pc">
                  <kw_list_progress :listFieldSet="pageSetInfo.listFieldSet" :pageSetInfo="pageSetInfo" :dataList="pageDataInfo" @callbackevent="callBackEvent" @refreshevent="initLoadDataInfo" ></kw_list_progress>
                </div>
              </template>
              <!-- 通知资讯 -->
              <template v-else-if="(pageSetInfo.listStyleSet.showStyle==22)">
                <template v-for="(pageDataInfo,dataIndex) in pageDataInfo" >
                  <van-notice-bar :key="'buttonId_'+dataIndex" color="#1989fa" background="#ecf9ff" left-icon="info-o">
                    {{pageDataInfo.NAME}}
                  </van-notice-bar>
                </template>
              </template>
              <!-- 饼图列表 -->
              <template v-else-if="(pageSetInfo.listStyleSet.showStyle==24)">
                <kw_list_pie :listFieldSet="pageSetInfo.listFieldSet" :pageSetInfo="pageSetInfo" :dataList="pageDataInfo" @callbackevent="callBackEvent" @refreshevent="initLoadDataInfo" :previewVisitSource="previewVisitSource" :isLimitButton="isLimitButton"></kw_list_pie>
              </template>
              <!-- 饼图列表(一个) -->
              <template v-else-if="(pageSetInfo.listStyleSet.showStyle==25)">
                <kw_list_pieOne :listFieldSet="pageSetInfo.listFieldSet" :pageSetInfo="pageSetInfo" :dataList="pageDataInfo" @callbackevent="callBackEvent" @refreshevent="initLoadDataInfo" :previewVisitSource="previewVisitSource" :isLimitButton="isLimitButton"></kw_list_pieOne>
              </template>
              <!-- 表格块列表 -->
              <template v-else-if="(pageSetInfo.listStyleSet.showStyle==26)">
                <kw_list_table_block :listFieldSet="pageSetInfo.listFieldSet" :pageSetInfo="pageSetInfo" :dataList="pageDataInfo" @callbackevent="callBackEvent" @refreshevent="initLoadDataInfo" :previewVisitSource="previewVisitSource" @getParentKwLook="getParentKwLook" :isLimitButton="isLimitButton"></kw_list_table_block>
              </template>
              <!-- 知识体系树列表 -->
              <template v-else-if="(pageSetInfo.listStyleSet.showStyle==27)" >
                <kw_seeks_relation :dataList="pageDataInfo" :pageSetInfo="pageSetInfo" :isLimitButton="isLimitButton" @refreshevent="initLoadDataInfo" :previewVisitSource="previewVisitSource" @getParentKwLook="getParentKwLook" ></kw_seeks_relation>
              </template>

              <!-- 判断如果是表格 展示则 增加分页组件 -->
              <template v-if="((pageSetInfo.listStyleSet.paginationWay == 1 || (!pageSetInfo.listStyleSet.paginationWay && (!pageSetInfo.listStyleSet.showStyle || pageSetInfo.listStyleSet.showStyle == 1 || pageSetInfo.listStyleSet.showStyle == ''))) && pageSetInfo.listStyleSet.loadingMore != 0)">
                <el-pagination :small="true"  @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="paginationInfo.currentPage" :page-sizes="[20, 30, 40, 50]" :page-size="paginationInfo.pageSize*1" :layout="pageSetInfo.listStyleSet.paginationLayout?pageSetInfo.listStyleSet.paginationLayout:(visitSource==2?'slot, total, sizes, prev, pager, next, jumper':'total, prev, pager, next')" :total="paginationInfo.total" :style="('padding:0px;width: 100%; overflow-y: scroll;')+(visitSource==3?'text-align: center;':'') + (pageSetInfo.listStyleSet.paginationStyleSet?pageSetInfo.listStyleSet.paginationStyleSet.styleSetCode:'')" kwName="paginationStyleSet">
                    <span v-if="pageSetInfo.ifSearchCount == 1" @click="loadPageDataCount">未加载记录数信息,当前显示虚拟记录数,如需查看请点击加载</span>
                </el-pagination>
              </template>
              <template v-else>
                <div v-if="(paginationInfo.dataStartNum < paginationInfo.total)">
                  <!-- <template v-else>   -->
                    <!-- 设置加载更多方式  loadingMore == 2 为跳转  默认或jumpIcon_pc1为当前页面展示更多-->
                    <div v-if="(pageSetInfo.listStyleSet.loadingMore && pageSetInfo.listStyleSet.loadingMore == 2)" bindtap="jumpToPage">
                      <span class="lookOver">查看全部任务></span>
                    </div>
                    <div v-else-if="(pageSetInfo.listStyleSet.loadingMore && pageSetInfo.listStyleSet.loadingMore == 0)"></div>
                    <div v-else @click="loadDataInfo" class="load_more_box">
                      <span class="load_more">
                        <el-link v-loading="clickLoadFlag">点击加载更多</el-link>
                      </span>
                    </div>
                  <!-- </template> -->
                </div>
                <template v-if="(pageSetInfo.listStyleSet.pageTotalStyle!=1 && pageSetInfo.listStyleSet.pageTotalStyle!=2)">
                  <div v-if="(paginationInfo.dataStartNum==paginationInfo.total && paginationInfo.total == 0)">
                    <div v-if="(paginationInfo.total == 0)">
                      <div v-if="(pageSetInfo.listStyleSet && pageSetInfo.listStyleSet.noDataMessage)" :style="pageSetInfo.listStyleSet.noDataMessageStyleSet?pageSetInfo.listStyleSet.noDataMessageStyleSet.styleSetCode:''" kwName="noDataMessageStyleSet">
                        {{pageSetInfo.listStyleSet.noDataMessage}}
                      </div>
                      <div  v-else-if="!ifLoadedData" :style="'padding: 5px 10px;'+(pageSetInfo.listStyleSet.noDataMessageStyleSet?pageSetInfo.listStyleSet.noDataMessageStyleSet.styleSetCode:'')" kwName="noDataMessageStyleSet">
                        加载中
                      </div>
                      <div  v-else :style="'padding: 5px 10px;'+(pageSetInfo.listStyleSet.noDataMessageStyleSet?pageSetInfo.listStyleSet.noDataMessageStyleSet.styleSetCode:'')" kwName="noDataMessageStyleSet">
                        没有相关数据
                      </div>
                    </div>
                    <div v-else :style="'padding: 5px 10px;'+(pageSetInfo.listStyleSet.noDataMessageStyleSet?pageSetInfo.listStyleSet.noDataMessageStyleSet.styleSetCode:'')" kwName="noDataMessageStyleSet">
                      我是有底线的
                    </div>
                  </div>
                </template>
              </template>
            </div>
          </el-col>
        </el-row>
        <!-- 列表展示数据 -->
        <!-- 如果是弹出层页面并判断是单选还是多选 如果为多选则出现确定 取消按钮 -->
        <el-row type="flex" justify="center" v-if="initPageObj.callBackType == 1 && dataMaxNum != 1">
          <el-col style="text-align: center;">
            <!-- <el-button-group v-if="initPageObj.callBackType == 1 && dataMaxNum != 1"> -->
              <el-button type="success" @click="dialogChoose">确定</el-button>
              <el-button type="danger" @click="dialogCancel">取消</el-button>
            <!-- </el-button-group> -->
          </el-col>
        </el-row>
      </el-container>
    </el-container>


    <!--visitSource = 3  移动端 -->
    <el-dialog class="zdy_dialog" v-if="dialogInfo.ifLoad" :visible.sync="dialogInfo.ifLoad" width="90%" top="1vh" center append-to-body :close-on-click-modal="false" v-dialogDrag>
      <template slot="title"> 
          <div>
            {{(dialogInfo.pageInfo&&dialogInfo.pageInfo.menuName)?dialogInfo.pageInfo.menuName:'弹出层'}}
          </div>    
      </template>
      <kw_list v-if="dialogInfo.type==1" ref="kw_list_dialog" :initPageObj="dialogInfo.pageInfo" :previewVisitSource="previewVisitSource" :isLimitButton="isLimitButton" :ifDialog="1"></kw_list>
      
      <kw_look v-else-if="dialogInfo.type==11" ref="kw_look_dialog" :pageInfo="dialogInfo.pageInfo" @goBack="dialogIframeZdyCancel" :previewVisitSource="previewVisitSource" :isLimitButton="isLimitButton" :ifDialog="1"></kw_look>
      <iframe v-else-if="dialogInfo.type==999" ref="dialog999" :style="'width:100%;height:' + (windowHeight-70) + 'px;'" frameborder=0 name="showHere" scrolling=auto  :src="dialogInfo.url" ></iframe>
      <span slot="footer" v-if="dialogInfo.type==999">
        <el-button @click="dialogIframeZdyCancel">取 消</el-button>
        <el-button type="primary" @click="dialogIframeZdyConfirm">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="导入" v-if="importDialogInfo.ifLoad" :visible.sync="importDialogInfo.ifLoad" width="50%" top="20vh" center append-to-body v-dialogDrag>
      <el-row justify="center">
        <el-col :span="24" style="text-align:center;">

          <!-- 上传文件按钮 :auto-upload="false"    -->
          <el-upload  ref="importUpload" drag :multiple="false" :limit="1" name="upload" :action="'/'+GLOBAL.projectName+'/import_importTable.do'" :http-request="zdyUploadImportFile" :data="importDialogInfo.uploadData" :with-credentials="true" :accept="'.xls,.xlsx'" >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传excel文件</div>
            <!-- <el-button style="margin-left: 10px;" size="small" type="success" @click="toUploadImportFile">上传到服务器</el-button> -->
          </el-upload>
          <!-- 下载导入模板按钮 -->
          <el-button style="margin:10px;" size="small" type="primary" @click="downLoadImportModel">下载导入模板</el-button>

        </el-col>
      </el-row>

    </el-dialog>

    <!-- 打开页面设置按钮 -->
    <div v-if="loginInfo.USERID == 0" style="position: absolute;right: 0;bottom: 0px;z-index:999999;opacity: 0.5;">
      <el-button @click="toOpenPageSet(1)" style="" title="小程序样式设置" icon="el-icon-mobile-phone" type='primary' ></el-button>
      <el-button @click="toOpenPageSet(2)" style="" title="PC样式设置" icon="el-icon-s-platform" type='primary' ></el-button>
    </div>  

  </div>
  <div v-else>
      <div v-if="visitSource == 2" style="display: flex;justify-content: center;padding: 10px 0">
          <i class="el-icon-loading"></i>
      </div>
      <div v-else>页面加载中!</div>
  </div>
</template>

<script>
// 搜索条件组件
import kw_search from '@/components/list/kw_search.vue';
// 默认的表格显示方式
import kw_list_default from '@/components/list/kw_list_default.vue';
// 左侧图片card显示
import kw_card_default from '@/components/list/kw_card_default.vue';
// 树形标签二级
import kw_tree_label from '@/components/list/kw_tree_label.vue';
// 选项卡列表
import kw_list_label from '@/components/list/kw_list_label.vue';
// 折叠面板列表
import kw_list_collapse from '@/components/list/kw_list_collapse.vue';
// 轮播图列表
import kw_list_carousel from '@/components/list/kw_list_carousel.vue';
// 树形结果
import kw_tree from '@/components/list/kw_tree.vue';
// 树形组件
import lmf_tree from '@/components/form/lmf_tree.vue';
// 单行列表
import kw_list_cell from '@/components/list/kw_list_cell.vue';
// 评论列表组件
import kw_list_comment from '@/components/list/kw_list_comment.vue';
// 搜索组件(kw_list_search) 
import kw_list_search from '@/components/list/kw_list_search.vue';
// 菜单产品类型
import kw_menu_lable from '@/components/list/kw_menu_lable.vue';
// 排行榜(kw_ranking_list)
import kw_ranking_list from '@/components/list/kw_ranking_list.vue';
// 进度条
import kw_list_progress from '@/components/list/kw_list_progress.vue';
// 饼图列表
import kw_list_pie from '@/components/list/kw_list_pie.vue';
// 饼图列表(一个)
import kw_list_pieOne from '@/components/list/kw_list_pieOne.vue';
// 表格块列表
import kw_list_table_block from '@/components/list/kw_list_table_block.vue';
// 知识图谱树列表
import kw_seeks_relation from '@/components/list/kw_seeks_relation.vue';


// 下拉树组件
import kw_tree_list from '@/components/list/kw_tree_list.vue';

// 列表的按钮组件
import kw_btn_array from '@/components/look/kw_btn_array.vue';

import { NoticeBar } from 'vant';


import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
export default {
  name: 'kw_list',
  props: {
    initPageObj:{
      type:Object,
      default:null
    },
    //主页面的数据主键
    mainId:{
      default:null
    },
    // 上级页面的下标信息
    parentTabIndex:{
      type: Number,
      default: null
    },
    ifShowSearch:{
      type: Number,
      default: 0
    },
    //是否是预览组件 如果为1则为预览组件
    isPreview:{
      type: Number,
      default: 0
    },
    //预览的页面设置信息
    previewPageSetInfo:{
      type:Object,
      default:function(){return {}}
    },
    //预览的数据信息
    previewPageDataInfo:{
      type:Array,
      default:function(){return []}
    },
    previewVisitSource:{
      type:Number,
      default:0
    },
    //按钮是否根据角色权限限制
    isLimitButton:{
      type: Boolean,
      default: false
    }
  },
  data() {
    var that = this;
    return {
      // 访问来源 PC:2 或者 H5:3
      visitSource:utils.checkVisitSource(that),
      // 是否显示加载中的状态
      isLoading:false,
      ifLoadedData:false,
      // 是否进行数据渲染
      hasLoad:false,
      //对象ID
      tableId:0,
      //页面ID
      pageId:0,
      //页面的穿透类型
      ctType:-1,
      //是关联穿透页面时,传递的页面主键
      SourceDataId:null,
      //如果是弹出层时,获取的关联搜索条件
      tmpJsonData:null,
      //主页面的tableId
      mainTableId:0,
      //主页面的pageId
      mainPageId:0,
      //需要默认选中的值
      initCheckId:null,
      //如果是弹出层 需要的选中个数
      dataMaxNum:0,
      //页面设置信息
      pageSetInfo:{},
      //页面数据信息
      pageDataInfo:[],
      // 从后台查询的未经过加工过的数据信息 目的是传递给搜索条件进行显示内容的改变
      htPageDataInfo:[],
      //分页信息
      paginationInfo:{
        //分页条数
        pageSize:20,
        //总记录数
        total:0,
        //当前是第几页
        currentPage:1,
        //当前读取了多少条数据
        dataStartNum:0
      },
      kwSearchToHtData:{},
      //异步加载数据的状态
      clickLoadFlag:false,
      //默认需要赋值的搜索条件 json 
      initSearchVal:"",
      //前端页面需要进行的数据过滤条件
      showDataFilter:null,
      //serach子组件传递给list的styleSet
      transmitData:{},
      // 搜索条件的折叠面板的展开状态
      kwSearchFlag:"0",
      /**
       * 弹出层组件的信息
       */
      dialogInfo:{
        ifLoad:false
      },
      // 左侧树的选中数据ID
      leftTreeDataId:"",
      //浏览器窗口页面高度
      pageHeight:0,
      // 排序字段
      sortBy:null,
      sortDir:null,
      //导入组件是否显示
      importDialogInfo:{
        ifLoad:false
      },
      intervalRefreshFun:null,
      loginInfo:{},
      //是否弹出层打开
      ifDialog:false
    };
  },
  created() {
    var that = this;
    that.pageHeight = window.innerHeight-65;
    var initPageObj = that.initPageObj;
    console.log("initPageObj============================",initPageObj);
    if (initPageObj) {
      that.tableId = initPageObj.tableId;
      that.pageId = initPageObj.pageId;
      that.mainTableId = initPageObj.mainTableId ? initPageObj.mainTableId:null;
      that.mainPageId = initPageObj.mainPageId?initPageObj.mainPageId:null;
      that.initCheckId = initPageObj.initCheckId?initPageObj.initCheckId:'';
      that.dataMaxNum = (initPageObj.dataMaxNum || initPageObj.dataMaxNum==0) ? initPageObj.dataMaxNum*1:0;
      that.initSearchVal = initPageObj.initSearchVal ? initPageObj.initSearchVal:'';
      that.tmpJsonData = initPageObj.tmpJsonData ? initPageObj.tmpJsonData:'';
      that.ctType = initPageObj.ctType ? initPageObj.ctType:-1;
      that.SourceDataId = initPageObj.SourceDataId ? initPageObj.SourceDataId:null;
      that.ifDialog = initPageObj.ifDialog ? initPageObj.ifDialog:false;
    }
    //根据pageId和tableId进行页面设置信息的加载
    // 判断是否在缓存中有当前页面设置的数据 
    var cacheStr = pageUtils.getSessionParam("pageSetCache_"+that.tableId+"_"+that.pageId);
    var cacheFlag = false;
    if(utils.isNotNull(cacheStr)) {
      var htData = JSON.parse(cacheStr);
      if (htData && htData.cacheStartTime) {
        let date = new Date().getTime();
        // 如果大于就是过期了，如果小于或等于就还没过期
        if (date - htData.cacheStartTime > htData.cacheExpiresTime) {
          localStorage.removeItem("pageSetCache_"+that.tableId+"_"+that.pageId);
        } else {
          cacheFlag = true;
          that.initListPageSet(htData,that);
        }
      } 
    } 
    // 判断是否是预览功能
    if(that.isPreview == 1) {
      this.previewInitLoad();
    } else {
      if(!cacheFlag) {
        pageUtils.loadListPageSet(that, that.initListPageSet);
      }
    }
    
  },
  mounted() {
    
  },
  beforeDestroy(){
    if(this.intervalRefreshFun) {
      clearInterval(this.intervalRefreshFun);
    }
  },
  watch:{
    previewPageSetInfo:{
      handler(newVal){
        this.previewInitLoad();
      },
      deep: true,
      immediate: true
    },
    previewPageDataInfo:function(newVal){
      this.previewInitLoad();
    },
    previewVisitSource:function(newVal){
      this.previewInitLoad();
    }
    // mainId(newV,oldV){

    // }
  },
  computed:{
  },
  components: {
    kw_search,
    kw_list_default,
    kw_card_default,
    kw_tree_label,
    kw_list_label,
    kw_list_collapse,
    kw_list_carousel,
    kw_tree,
    lmf_tree,
    kw_list_cell,
    kw_list_comment,
    kw_list_search,
    kw_menu_lable,
    kw_ranking_list,
    kw_list_progress,
    kw_list_pie,
    kw_list_pieOne,
    kw_list_table_block,
    kw_seeks_relation,
    kw_btn_array,
    kw_tree_list,
    NoticeBar,
    kw_look:resolve => require(['@/components/look/kw_look.vue'], resolve),
    kw_list:resolve => require(['@/components/list/kw_list.vue'], resolve)
  },
  methods: {
    /**
     * 初始化列表页面的页面设置信息
     */
    initListPageSet(htData,that){
      var pageSetInfo = htData.pageSet;
      var pageId = that.pageId;
      var paginationInfo = that.paginationInfo;
      if(pageSetInfo.ifUnfoldsrch == 1) {
        that.kwSearchFlag = "1";
      }
      if (pageSetInfo.pageLimit) {
        paginationInfo.pageSize = pageSetInfo.pageLimit;
      }
      if(pageSetInfo.listStyleSet && pageSetInfo.listStyleSet.pageLimit) {
        paginationInfo.pageSize = pageSetInfo.listStyleSet.pageLimit;
      }
      pageUtils.initTotalButtonSet(pageSetInfo, pageId, that);
      pageUtils.initOperaButtonSet(pageSetInfo, pageId, that);
      if (pageSetInfo.childTabs) {
        for (var i = 0; i < pageSetInfo.childTabs.length; i++) {
          var childTabOne = pageSetInfo.childTabs[i];
          if(!childTabOne.styleSet){
            childTabOne.styleSet = {};
          }
          // 判断是否有加号展开页面 并且设置未表格追加 如果有怎进行一次页面设置读取并缓存
          pageUtils.loadListPageSet({
            tableId:childTabOne.tableId,
            pageId:childTabOne.pageId,
            mainId:0,
            $axios:that.$axios
          }, that.initCacheChildPageSet);
        }
      } else {
        pageSetInfo.childTabs = [];
      }
      if(pageSetInfo.tableId > 0) {
        that.tableId = pageSetInfo.tableId;
      }
      pageSetInfo.pageId = pageId;
      if(!pageSetInfo.listStyleSet) {
        pageSetInfo.listStyleSet = {};
      }
      if(!pageSetInfo.searchStyleSet) {
        pageSetInfo.searchStyleSet = {};
      }
      if(!pageSetInfo.styleSet) {
        pageSetInfo.styleSet = {};
      }
      if(!pageSetInfo.operaButtonSet) {
        pageSetInfo.operaButtonSet = {};
      }
      if(pageSetInfo.listFieldSet) {
        pageSetInfo.listFieldSet.forEach(fieldOne => {
          if(!fieldOne.styleSet) {
            fieldOne.styleSet = {};
          }
          //如果默认为表格样式 进行表头 判断字体如果大于6个

        });
      }

      that.pageSetInfo = pageSetInfo;
      that.paginationInfo = paginationInfo;
      pageUtils.loadInitSearchSet(that);
      if(utils.isNotNull(localStorage.loginInfo)) {
        var loginInfo = JSON.parse(localStorage.loginInfo);
        that.loginInfo = loginInfo;
      }
      // 进行页面渲染
      that.hasLoad = true;
      //自定义customVueJs
      if(pageSetInfo.customVueJs) {
        eval(pageSetInfo.customVueJs);
      }
      if(that.isPreview == 1) {

      } else {
        //调用一次数据加载
        that.$nextTick(function(){
          that.initLoadDataInfo();
        });
      }
    },
    /**
     * 缓存子页面的页面设置信息
     */
    initCacheChildPageSet(htData,that){
      htData.cacheStartTime = new Date().getTime();
      htData.cacheExpiresTime =  10000;
      var cacheStr = JSON.stringify(htData);
      pageUtils.setSessionParam("pageSetCache_"+that.tableId+"_"+that.pageId,cacheStr);

    },
    /**
     * 初始化分页信息 并去后台加载数据
     */
    initLoadDataInfo(){
      var that = this;
      var paginationInfo = that.paginationInfo;
      paginationInfo.total = 0;
      //当前是第几页
      paginationInfo.currentPage = 1;
      //当前读取了多少条数据
      paginationInfo.dataStartNum = 0;
      that.htPageDataInfo = [];
      that.paginationInfo = paginationInfo;
      that.ifLoadedData = false;
      that.loadDataInfo(1);
      //判断是否设置自动刷新数据间隔
      if(that.pageSetInfo.listStyleSet && that.pageSetInfo.listStyleSet.autoRefreshDataSecond > 0) {
        that.intervalRefreshFun = setInterval(function(){
          that.loadDataInfo(1);
        }, that.pageSetInfo.listStyleSet.autoRefreshDataSecond*1000);
      }
    },
    /**
     * 去后台进行数据加载
     */
    loadDataInfo(ifInit){
      var that = this;
      var paginationInfo = that.paginationInfo;
      var pageDataInfo = that.pageDataInfo;
      var pageSetInfo = that.pageSetInfo;
      var dataStartNum = pageDataInfo.length;
      if (ifInit == 1) {
        pageDataInfo = [];
        //已查询数据的记录数
        dataStartNum = pageDataInfo.length;
      } else if(ifInit == 2) {
        pageDataInfo = [];
        dataStartNum = paginationInfo.pageSize * (paginationInfo.currentPage-1);
      }

      //如果当前记录数=总记录数 则不显示
      if (dataStartNum == paginationInfo.total && paginationInfo.total != 0) {
        return;
      }
      var toHtData = {};
      // 进行后台数据加载时,进行一些相关参数的逻辑处理
      that.loadDataSearchHandle(toHtData);

      //传递到后台用于搜索的参数
      //分页信息 
      
      //ifSpecialPage  sql优化是否开启  一般默认为开启
      toHtData.ifSpecialPage = pageSetInfo.ifSpecialPage;
      //ifAjaxCount  是否ajax加载记录数 如果当前分页为第一页 则加载记录数设置为false  如果当前分页不为第一页则设置为true
      toHtData.ifAjaxCount = false;
      if (dataStartNum != 0) {
        toHtData.ifAjaxCount = true;
      }
      //判断是否是树形表格 ifParent
      if (pageSetInfo.ifParent == 1) {
        toHtData.ifTree = 1;
      } else {
        toHtData.start = dataStartNum;
        toHtData.limit = paginationInfo.pageSize + "_flow";
      }
      that.clickLoadFlag = true;
      that.isLoading = true;
      var ajaxListUrl = 'model_ajaxList.do';
      if (pageSetInfo.pageType == 16) {
        ajaxListUrl = 'treeDialog_wxxcxAjaxList.do';
      }
      if(pageSetInfo.tableType == 10) {
        ajaxListUrl = 'mongoModel_ajaxList.do';
      }
      utils.request(that,{
        url: ajaxListUrl, //读取列表数据的接口
        data: toHtData,
        success: function (res) {
          pageDataInfo = pageDataInfo.concat(res.data.rows);
          //如果是第一页读取 则赋值记录数 如果不是第一页读取则不用读取记录数
          if (dataStartNum == 0) {
            paginationInfo.total = res.data.total*1;
          }
          paginationInfo.dataStartNum = pageDataInfo.length;
          //判断是否进行页面数据过滤

          var htPageDataInfo = JSON.parse(JSON.stringify(pageDataInfo));

          //当前的显示的分页条数进行计算
          that.htPageDataInfo = htPageDataInfo;
          that.clickLoadFlag = false;
          that.ifLoadedData = true;
          that.isLoading = false;
          if (that.showDataFilter == null) {
            that.pageDataInfo = pageDataInfo;
            that.paginationInfo = paginationInfo;
          } else {
            that.changeDataByFilter();
          }
          if (ifInit == 1) {
            that.loadDataAfterCallBack();
          }
        },
        fail: function () {
          that.isLoading = false;
          //数据加载失败提示
          that.$notify.error({
            title: '失败',
            message: '数据加载失败，请重试！',
            duration: 2000
          });
        }
      })
    },
    /**
     * 进行后台数据加载时,进行一些相关参数的逻辑处理
     */
    loadDataSearchHandle(toHtData){
      var that = this;
      //tableId 表id
      toHtData.tableId = that.tableId;
      //pageId 页面id
      toHtData.pageId = that.pageId;
      
      var searchThData = that.kwSearchToHtData;
      toHtData = Object.assign(toHtData, searchThData);
      //ctType=-1 报表或者消息穿透页面类型 暂时默认为 -1 之后如果做报表穿透再启用
      toHtData.ctType = that.ctType;
      //SourceDataId 报表或者消息 穿透页面的过滤条件
      var SourceDataId = that.SourceDataId;
      if (SourceDataId != null) {
        toHtData.SourceDataId = SourceDataId;
      }

      //isOnlyCount  是否只查询记录数
      toHtData.isOnlyCount = false;
      // 判断是否有全局过滤主键条件 如果有则进行valuePlug的传递绑定
      if(localStorage.globalLookIdJson) {
        var globalLookIdJson = JSON.parse(localStorage.globalLookIdJson);
        if (globalLookIdJson) {
          for (var key in globalLookIdJson) {
            var tmpPageId = globalLookIdJson[key].pageId;
            var tmpMainId = globalLookIdJson[key].mainId;
            toHtData["valuePlug_" + tmpPageId] = tmpMainId;
          }
        }
      }

      //判断是否需要把 弹出层的过滤条件 tmpJsonData 传递到后台
      var tmpJsonData = that.tmpJsonData;
      if (tmpJsonData != null && tmpJsonData.length > 0) {
        var toHtArr = tmpJsonData.split("!");
        for (var i = 0; i < toHtArr.length; i++) {
          var oneArr = toHtArr[i].split("#");
          if (oneArr.length > 1) {
            toHtData[oneArr[0]] = oneArr[1];
          }
        }
      }


      //是否是列表加号展开页面或者关联选项卡
      var mainId = that.mainId;
      var mainTableId = that.mainTableId;
      var mainPageId = that.mainPageId;
      if (mainId || mainTableId > 0) {
        toHtData.mainId = mainId;
        toHtData.mainTableId = mainTableId;
        toHtData.mainPageId = mainPageId;
      }

      //判断是否需要把 当前选中 也就是排序 传递到后台
      var initCheckId = that.initCheckId;
      if (initCheckId && initCheckId != "" ) {
        toHtData.orderDataId = initCheckId;
      }

      // 判断是否有左侧树的选中条件
      
      var leftTreeTjPlugId = that.pageSetInfo.leftTreeTjPlugId;
      var leftTreeDataId = that.leftTreeDataId;
      var leftTreePageId = that.pageSetInfo.leftTreePageId;
      if(leftTreeDataId != "" && leftTreeDataId!=0) {
        if(leftTreeTjPlugId) {
          if(typeof(leftTreeTjPlugId) == "object") {
            leftTreeTjPlugId.forEach(leftTreeTjPlugIdOne => {
              toHtData["valuePlug_" + leftTreeTjPlugIdOne] = leftTreeDataId;
            });
          } else if(leftTreeTjPlugId > 0) {
            toHtData["valuePlug_" + leftTreeTjPlugId] = leftTreeDataId;
          }
        } else {
          toHtData["valuePlug_" + leftTreePageId] = leftTreeDataId;
        }
      }

      //判断是否有对应的排序字段 如果有则把点击排序信息传递到后台
      if(that.sortBy != null && that.sortDir != null) {
        toHtData.sortBy = that.sortBy;
        toHtData.sortDir = that.sortDir;
      }
    },
    /**
     * 进行数据的页面显示过滤 
     */
    setShowDataFilter(e){
      // 获取搜索组件 判断是否有需要进行过滤的数据 日期组件需要进行数据过滤
      var showDataFilter = e;
      this.showDataFilter = showDataFilter;
      this.changeDataByFilter();
    },
    /**
     * 根据前端的页面数据显示过滤条件进行显示数据的切换
     */
    changeDataByFilter(){
      var that = this;
      var showDataFilter = that.showDataFilter;
      if (showDataFilter != null) {
        var pageDataInfo = [];
        var htPageDataInfo = that.htPageDataInfo;
        htPageDataInfo.forEach(one=>{
          var flag = true;
          for (var key in (showDataFilter)) {
            if(showDataFilter[key] != one[key]){
              flag = false;
            }
          }
          if (flag) {
            pageDataInfo.push(one);
          }
        })
        var paginationInfo = that.paginationInfo;
        paginationInfo.total = pageDataInfo.length;
        that.pageDataInfo = pageDataInfo;
        that.paginationInfo = paginationInfo;
      }
    },
    /**
     * 数据加载完成之后 需要回调的事件 
     * 例如修改查看页面的选项卡的信息或查看页面信息
     */
    loadDataAfterCallBack(){
      var paginationInfo = this.paginationInfo;
      var pageDataInfo = this.pageDataInfo;
      var myEventDetail = {
        clickType: 2,
        total: paginationInfo.total,
        pageDataInfo:pageDataInfo,
        parentTabIndex: this.parentTabIndex
      }
      this.$emit("zdyParentEvent",myEventDetail);
      // this.triggerEvent('zdyParentEvent', myEventDetail);
    },
    /**
     * 列表头图的点击跳转事件
     */
    listBgImageJump(){
      var pageInfo = this.pageSetInfo;
      var styleSet = pageInfo.listStyleSet;
      if (styleSet.imageClickType == 3) {
        // 跳转到列表页面
        var clickPageId = styleSet.imageClickPageId;
        var clickTableId = styleSet.imageClickTableId;
        var toListJson = {
          pageId: clickPageId,
          tableId: clickTableId,
          initCheckId: 0,
          callBackType: 0,
          dataMaxNum: 1
        }
        //判断是否有 传递的默认搜索条件 如果有则进行穿度
        pageUtils.toNewListPage(this,toListJson);
      } 
    },
    /**
     * 页面的按钮点击事件
     */
    pageButtonClick(buttonOne,dataInfo) {
      pageUtils.dataButtonClick(this,buttonOne,null);
    },

    /**
     * 列表数据选中时的回调事件
     */
    callBackEvent: function(detail){
      var that = this;
      var initPageObj = that.initPageObj;
      var clickValue = detail.val;
      var checkDataInfo = detail.checkDataInfo;
      // callBackType == 2 代表是查看页面的切换组件
      if (initPageObj.callBackType == 1) {
        // 弹出层组件赋值
        this.$emit('dialogClickCallBack', detail);
      } else if (initPageObj.callBackType == 2) {
        // 查看页面主键修改 查看组件刷新
      }
    },
    /**
     * 如果是弹出层页面 点击确定时进行数据选中
     */
    dialogChoose:function(){
      var that = this;
      if(this.$refs.kw_list_default) {
        var kw_list_default = typeof(this.$refs.kw_list_default.length)=='number'?this.$refs.kw_list_default[0]:this.$refs.kw_list_default;
        if(kw_list_default && kw_list_default.selectionNodes.length >= 0) {
          var tableId = this.tableId;
          var valId = "";
          kw_list_default.selectionNodes.forEach(dataInfo => {
            valId += (valId==""?"":",") + dataInfo["T_" + tableId + "_0"]
          });
          var myEventDetail = {
            val: valId,
            checkDataInfo: kw_list_default.selectionNodes
          }
          this.$emit('dialogClickCallBack', myEventDetail);
        }
      }
      if(this.$refs.kw_card_default) {
        var kw_card_default = typeof(this.$refs.kw_card_default.length)=='number'?this.$refs.kw_card_default[0]:this.$refs.kw_card_default;
        if(kw_card_default) {
          if(that.pageDataInfo) {
            var checkedId = '';
            var checkDataInfo = [];
            that.pageDataInfo.forEach(dataInfo => {
                if(dataInfo.RADIO_CHECK_STATE) {
                    checkedId += (checkedId==""?"":",") + dataInfo["T_" + that.tableId + "_0"];
                    checkDataInfo.push(dataInfo);
                }
            });
            var myEventDetail = {
              val: checkedId,
              checkDataInfo: checkDataInfo
            }
            this.$emit('dialogClickCallBack', myEventDetail);
          }
        }
      }
    },
    /**
     * 如果是弹出层页面 点击取消时进行数据选中
     */
    dialogCancel:function(){
      this.$emit('closeDialog');
    },
    /**
     * 返回前一页
     */
    goBack(){
      console.log("kw_list--------------goBack----------------");
      this.$emit("goBack");
    },
    /**
     * 弹出层打开iframe时的确定按钮
     */
    dialogIframeZdyConfirm(){
      var that = this;
      that.$refs.dialog999.contentWindow.closeDialogFun=function(){
        that.dialogInfo.ifLoad = false;
      };
      that.$refs.dialog999.contentWindow.saveZdyPage();
    },
    /**
     * 弹出层打开iframe时的取消按钮
     */
    dialogIframeZdyCancel(ifRefresh){
      var that = this;
      this.dialogInfo.ifLoad = false;
      if(ifRefresh == 1) {
        this.refreshevent();
      }
    },
    /**
     * 刷新时的方法
     */
    refreshevent(sortBy,sortDir){
      var that = this;
      var listStyleSet = this.pageSetInfo.listStyleSet;
      if (listStyleSet && listStyleSet.refreshType == 2) {
        var kw_look = null;
        that.getParentKwLook(val => {
            kw_look = val
        });
        if(kw_look) {
            kw_look.refreshevent();
        }
        // var nowPage = that.$router.app.$children[0].$children[0];
        // // 调用整个页面的刷新方法
        // nowPage.zdyRefreshPage();
      } else if(listStyleSet && listStyleSet.refreshType == 3){
        // 刷新页面所有列表
        var kw_look = null;
        that.getParentKwLook(val => {
            kw_look = val
        });
        if(kw_look) {
          var pageSetInfo = kw_look.pageSetInfo;
          if(pageSetInfo.tabPageSet){
            for (var i = 0; i < pageSetInfo.tabPageSet.length; i++) {
              if(kw_look.$refs["kw_list_" + i] && kw_look.$refs["kw_list_" + i].length>0) {
                kw_look.$refs["kw_list_" + i][0].initLoadDataInfo();
              }
            }
          }
        }
      } else {
        if(sortBy != null && sortDir != null) {
          that.sortBy = sortBy;
          that.sortDir = sortDir;
        } else {
          that.sortBy = null;
          that.sortDir = null;
        }
        this.initLoadDataInfo();
        // 判断是否有左侧树 有的话进行刷新
        if(that.pageSetInfo.leftTreePageId) {
          that.$refs.kw_list_left_tree.loadDataInfo();
        }
      }
    },
     /**
     * 分页条数切换时触发
     */
    handleSizeChange(val) {
        this.paginationInfo.pageSize = val;
        //调用数据初始化搜索
        this.initLoadDataInfo();
    },
    /**
     * 选择分页 当前页时触发
     */
    handleCurrentChange(val) {
        this.paginationInfo.currentPage = val;
        //调用数据搜索
        this.loadDataInfo(2);
    },
    /**
     * 预览页面时进行数据加载
     */
    previewInitLoad() {
      var that = this;
      if(that.isPreview == 1) {
        var previewPageSetInfo = JSON.parse(JSON.stringify(this.previewPageSetInfo));
        previewPageSetInfo.listFieldSet = previewPageSetInfo.fieldSet;
        var fieldSet = [];
        previewPageSetInfo.fieldSet = fieldSet.concat(previewPageSetInfo.searchSet,previewPageSetInfo.dynamicSearchSet);
        if(previewPageSetInfo.childTabs) {
          previewPageSetInfo.childTabs.forEach(tabPageOne => {
            tabPageOne.tableId = tabPageOne.glPageObj;
            tabPageOne.pageId = tabPageOne.childPage;
          });
        }
        this.initListPageSet({
          pageSet:previewPageSetInfo
        },this);
        this.pageDataInfo = this.previewPageDataInfo;
        this.visitSource = this.previewVisitSource;

        this.ifLoadedData=true;
        this.hasLoad=false;
        this.$nextTick(function(){
          // that.ifLoadedData=true;
          that.hasLoad=true;
        })
      }
    },
    /**
     * 左侧树点击的回调事件
     */
    leftTreeClick(leftTreeDataId) {
      this.leftTreeDataId = leftTreeDataId;
      this.initLoadDataInfo();
    },
    /**
     * 下载导入模板
     */
    downLoadImportModel() {
      var that = this;
      var url = "import_makeModel.do";
      var toHtData = that.getToImportParamJson();
      pageUtils.downLoadFile(url,toHtData,that.pageSetInfo.pageName+"导入模板.xls",that);
    },
    /**
     * 获取上传文件需要传到后台的参数
     */
    getToImportParamJson:function(type){
      var that = this;
      var buttonOne = that.importDialogInfo.buttonOne;
      var importFields = buttonOne.importFields;
      var zdyCnNameStr = buttonOne.zdyCnNameStr;
      var impFieldList = buttonOne.impFieldList;
      var remarkStr = buttonOne.remarkStr;
      var toHtData = {};
      var impBox = buttonOne.mustFieldStr?buttonOne.mustFieldStr.split("@"):"";
      var importStr = [];
      var zdyCnName = [];
      var remark = [];
      var fieldc = [];
      var realNames = "";
      var zdyNames = "";
      var mustFieldNames = "";
      var zdyCnNameArr = zdyCnNameStr.split("卐");
      for (let index = 0; index < importFields.length; index++) {
        const importFieldsOne = importFields[index];
        const zdyCnNameOne = zdyCnNameArr[index];
        importStr.push(importFieldsOne.importStr);
        const zdyCnNameOneNVArr = zdyCnNameOne.split("@");
        zdyCnName.push(zdyCnNameOneNVArr[1]);
        zdyNames+=(zdyNames.length>0?",":"")+zdyCnNameOneNVArr[1];
        var rmk = "";
        if (("卐"+remarkStr+"@").indexOf("卐"+importFieldsOne.importStr+"@")>=0){
          rmk = ("卐"+remarkStr+"卐").substr(("卐"+remarkStr+"@").indexOf("卐"+importFieldsOne.importStr+"@"),("卐"+remarkStr+"@").length);
          rmk = rmk.split("卐")[1];
          rmk = rmk.split("@")[1];
        }
        remark.push(rmk);
        fieldc.push(importFieldsOne.fieldId);
        realNames+=(realNames.length>0?",":"")+importFieldsOne.fieldCnName;
        if(("@" + buttonOne.mustFieldStr + "@").indexOf("@" + importFieldsOne.fieldId + "@") >= 0) {
          mustFieldNames+=(mustFieldNames.length>0?",":"")+zdyCnNameOneNVArr[1];
        }
      }
      var relvalue = '';
      var fieldList = buttonOne.fieldList;
      if(fieldList) {
        fieldList.forEach(fieldOne => {
          var relvalueOne=fieldOne.fieldId;
          for(var i=0;i<impFieldList.length;i++){
            if(fieldOne.fieldId==impFieldList[i].split("#")[0]){
                relvalueOne=impFieldList[i].split("#")[1];
                var cnName = zdyCnName[i];
                relvalueOne = cnName+":"+relvalueOne;
            }
          }
          relvalue+=relvalueOne+",";
        });
      }
      if(type == "upload") {
        toHtData.relvalue = relvalue;
        toHtData.realNames = realNames;
        toHtData.zdyNames = zdyNames;
        toHtData.mustFieldNames = mustFieldNames;
        toHtData.ifExeOtherTrigger = that.pageSetInfo.ifExeOtherTrigger;
      } else {
        toHtData.impBox = impBox;
        toHtData.importStr = importStr;
        toHtData.zdyCnName = zdyCnName;
        toHtData.remark = remark;
        toHtData.pageId = that.pageId;
        toHtData.fieldc = that.fieldc;
      }
      return toHtData;
    },
    zdyUploadImportFile:function(param){
      var that = this;
      var fileObj = param.file;
      // FormData 对象
      var form = new FormData();
      // 文件对象,key是后台接受的参数名称
      form.append("upload", fileObj);
      var uploadData = this.importDialogInfo.uploadData;
      Object.keys(uploadData).forEach((key) => {
        form.append(key, uploadData[key]);
      });
      var url = "import_importTable.do";
      var zdyHead = that.$axios.defaults.headers;
      that.$axios({
          // 用axios发送post请求
          method: "post",
          // headers: {'Content-Type':'multipart/form-data'},
          url:url, // 请求地址
          data: form, // 参数
          responseType: "blob", // 表明返回服务器返回的数据类型
      }).then((res) =>{
        var response = res.data;
        // 这里做上传后的操作
        // content.onSuccess('配时文件上传成功')
        
        if(response.type == 'text/plain') {
          var reader = new FileReader();
          var resultMessage = "";
          reader.onload = function() {
            resultMessage = reader.result;//内容就在这里
            that.$message({
              message: resultMessage,
              type: resultMessage == "导入成功！"?'success':'error'
            });
          }
          reader.readAsText(response);
        } else {
          var fileName = "导入失败的数据.xls";
          const content = response;
          const blob = new Blob([content]);
          if ("download" in document.createElement("a")) {
              // 非IE下载
              const elink = document.createElement("a");
              // if(!fileName) {
              //     fileName = "下载文件.kw"
              // }
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href); // 释放URL 对象
              document.body.removeChild(elink);
          } 
          else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
          }
        }
        that.importDialogInfo.ifLoad = false;
      });
    },
    /**
     * 获取最外层的的kw_look组件
     */
    getParentKwLook(callback) {
      console.log("kw_list========getParentKwLook========");
      if(this.$listeners['getParentKwLook']){
        var parentKwLook;
        this.$emit("getParentKwLook",val => {
            parentKwLook = val
        });
        if(callback) {
          callback(parentKwLook);
        } else {
          return null;
        }
      } else {
        if(callback) {
          callback(null);
        } else {
          return null;
        }
      }
    },
    /**
     * 打开页面设置功能
     */
    toOpenPageSet(sourceType) {
      var that = this;
      let routeData = that.$router.resolve({
        name: 'PageShowSet',
        query: {
            pageId:that.pageId,
            sourceType:sourceType
        }
      })
      console.log("routeData.href================",routeData.href);
      window.open(routeData.href, '_blank')
    },
    /**
     * 清空搜索条件
     */
    clearSearchVal(){
      this.$refs["kw_search_"+this.tableId].clearSearchVal();
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .load_more_box{text-align: center;color: #FD4D12;padding: 10px 0 20px}
  .load_more{position: relative}
  .load_more:before{content: '';position: absolute;border-top: 1px solid #DDDEE1;display: inline-block;top: 10px;left: -60px;width: 50px}
  .load_more:after{content: '';position: absolute;border-top: 1px solid #DDDEE1;display: inline-block;top: 10px;left: 90px;width: 50px}
.currentTitle{font-size: 14px;padding: 10px;margin: 0 10px;background: #ffffff;
/* border-left: 1px solid #F1F1F1;border-right: 1px solid #F1F1F1; */
}
.currentTitle span{color: #FF6400;}
.chooseProBtn {position:absolute;right:20px;top:5px;color: #6F6F6F;font-size: 16px;transform: rotate(90deg);font-weight: bold;}
.chooseProBtnPC {position:absolute;right:0;top:25px;color: #6F6F6F;font-size: 16px;transform: rotate(90deg);font-weight: bold;}
.lookOver{color: #656565;font-size: 14px;display: block;text-align: center;padding: 15px 0;margin: 0 10px;background: #ffffff;border: 1px solid #F1F1F1;border-top: none}

.xueTit {display:flex;justify-content: space-between;background: #fff}
.xueTit .rightTit {color:#666666}

.progressContent {margin:10px;box-shadow: 0 0 15px #ddd;border-radius: 10px;padding:10px 10px 80px;}
.progressContent_pc {margin:10px;box-shadow: 0 0 15px #ddd;border-radius: 10px;padding:10px 10px 80px;background: #fff}
.listCon {position:relative;}
.listButtonPc{font-size: 14px;display: inline-block;text-align: center;vertical-align: middle;color: #FFF;background-color: #409EFF;border-color: #409EFF;border: 1px solid #DCDFE6;padding: 6px 14px;border-radius: 4px;}
</style>
<style>
  .el-pagination--small .el-select--mini{line-height: 22px !important;height: 22px !important;}
  .el-pagination--small .el-select--mini .el-input__inner{line-height: 22px !important;height: 22px !important;}
  .el-pagination--small .btn-prev{margin: 2px 0 0 0 !important;}
  .el-pagination--small .el-pager{margin: 2px 0 0 0 !important;}
  .el-pagination--small .btn-next{margin: 2px 0 0 0 !important;}
  .el-pagination--small .el-pagination__sizes{margin-top: 2px !important;}
  .phone_collapse .el-collapse-item__arrow {margin: 0 8px 0 5px !important;}
</style>
